module.exports = __webpack_public_path__ + "img/b_17.3d2459cd.jpg";